import React, { useEffect, useState } from 'react'
import Spinwheel from '../../../common/Spinwheel'
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import AsyncSelect from 'react-select/async';
import { getMovieTicketByIdApi } from '../../../../utils/ApiEndpointFunctions';
import moment from 'moment';
import { ImageUrl } from '../../../../utils/BaseUrl';
import { Link } from 'react-router-dom';

function ViewMovieTicket({ movieId, modalId, }) {
   const [data, setData] = useState({})
   const [loading, setLoading] = useState(true)


   const getMovieTicket = async () => {
      try {
         const res = await getMovieTicketByIdApi(movieId)
         if (res.status === 200 && res.data?.data?.[0]) {
            setData(res.data?.data?.[0]);
         }
         setLoading(false)
      } catch (error) {
         // setLoading(true)
      }
   }

   useEffect(() => {
      if (movieId) {
         getMovieTicket()
      }
   }, [movieId])


   return (
      <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
         <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
               <div className="modal-header border-0">
                  <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close"></button>
               </div>
               <div className="modal-body">
                  <div className="col-lg-12" style={{ zIndex: "1" }}>
                     <div action="" className='p-4' >
                        <h1 className='text-center'>
                           Movie ticket
                        </h1>
                        {loading ?
                           <Spinwheel /> :
                           <div className="row">
                              <div className="row row-cols-lg-3 row-cols-md-2">
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Movie</h4>
                                    <div className='position-relative'>
                                       <div className="avatar avatar-xs align-middle me-2">
                                          <img
                                             className="avatar-img rounded-circle"
                                             src={data?.movie?.coverImg ? ImageUrl + data?.movie?.coverImg : process.env.PUBLIC_URL + "/images/person-circle.svg"}
                                             alt=""
                                          />
                                       </div>
                                       <p className='mb-0'>{data?.movie?.name}</p>
                                    </div>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Cinema name</h4>
                                    <p className='text-capitalize mb-0'>{data?.movieCinema?.name}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Cinema location</h4>
                                    <p className='text-capitalize mb-0'>{data?.movieCinema?.location}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Show date</h4>
                                    <p className='text-capitalize mb-0'>{data?.movieShow?.timeDate ? moment(data?.movieShow?.timeDate).format("DD/MM/YYYY") : "-"}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Show timing</h4>
                                    <p className='text-capitalize mb-0'>{data?.movieShow?.timeDate ? moment(data?.movieShow?.timeDate).format("h:mm a") : "-"}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Language</h4>
                                    <p className='text-capitalize mb-0'>{data?.movieShow?.language || "-"}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Payment amount</h4>
                                    <p className='mb-0'>{data?.payment?.amount}</p>
                                 </div>
                                 <div className="mb-3">
                                    <h4 className='fw-bold'>Payment status</h4>
                                    <p className='mb-0'>{data?.payment?.status == "success" ? "Yes" : "No"}</p>
                                 </div>
                              </div>
                              <hr />
                              <div className="row row-cols-lg-3 row-cols-md-2">
                                 <div>
                                    <h4 className='fw-bold'>Tickets</h4>
                                    <p className='mb-0'>{data?.noOfTicket}</p>
                                 </div>
                                 <div>
                                    <h4 className='fw-bold'>Status</h4>
                                    <p className='mb-0'>{data?.status}</p>
                                 </div>
                                 <div>
                                    {data?.ticketFile && <div>
                                       <h4 className='fw-bold'>Attachment</h4>
                                       <Link to={ImageUrl + data?.ticketFile} target='_blank'>
                                          View
                                       </Link>
                                    </div>}
                                 </div>
                              </div>
                              <hr />
                           </div>}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default ViewMovieTicket